/**
 * get-venue 响应里「进了哪家店」的那一步（`utils/request/requestMixin.js` 的 get-venue 分支调用）。
 *
 * 1. 换了店（`data.id !== state.venueId`）就把上一家店的状态全清 —— 这五个 reset 与以前拦截器里写的一字不差、顺序不变；
 * 2. **紧接着**把这一单的 seed 绑到这家店的 UUID（多版本菜单 B6 修复）。
 *
 * 以前只有第 1 步，而 `initState` 里 `orderSeed: null`：`App.vue` 在 get-venue **之前**刚生成的 seed 被 resetState 清掉，
 * 首页紧跟着发的 get-menu 就没有 seed（后端实验分组拿空 seed 不分组，下单时又是另一个 seed）。
 * 现在第一个菜单请求（venue-home 的 get-menu 在它自己的 get-venue 回来之后才发）之前 seed 一定在，而且是下单会用的那一个。
 */
export const VENUE_RESET_MUTATIONS = [
  'resetState',
  'resetAppState',
  'resetCartState',
  'resetContactDetailsState',
  'resetVenueHomeState'
]

/**
 * @param {Object} store Vuex store
 * @param {{id: String, url_id?: String}} venue get-venue 的 data
 * @returns {Boolean} 是不是换了店（调用方据此决定要不要补存门店时间，与以前一样）
 */
export function enterVenue(store, venue) {
  const changed = venue.id !== store.state.venueId
  if (changed) {
    VENUE_RESET_MUTATIONS.forEach(mutation => store.commit(mutation))
    // 立刻记下进了哪家店（以前只有 App.vue 在它自己的 get-venue 回来后才存）：SP 模式首页的 get-venue 先回、App 的后回时，
    // 第二次不再当成「换了店」再清一遍 —— 那会抹掉刚解析好的 menuId、换掉 seed（U-B6-1 review）
    store.commit('saveVenueId', venue.id)
  }
  store.dispatch('bindOrderSeedToVenue', { venueId: venue.id, urlId: venue.url_id })
  return changed
}
